import { AppRoutes } from "../../routes";

export const getBaseDetailPopOutUrl = (callId: string) =>
  `${window.location.origin}/${AppRoutes.Root}/${AppRoutes.AuxWindow}/${AppRoutes.EventDetails}/${callId}`;
